<template>
  <div class="app-home">
    <el-carousel class="home-carousel" :interval="5000" height="24vw">
      <el-carousel-item class="home-carousel" v-for="(item,index) of sliderList" :key="index">
        <el-image style="width: 100%;height: 100%;" :src="item.url" alt="轮播图1" />
      </el-carousel-item>
    </el-carousel>

    <!-- 添加公告通知组件 -->
    <div class="notice-bar" v-if="notice.length > 0 && !noticeHidden">
      <i class="el-icon-bell"></i>
      <div class="notice-content">
        <transition-group name="notice" tag="ul">
          <li v-for="(item, index) of notice" :key="index" v-show="index === currentNoticeIndex" v-html="item.content"></li>
        </transition-group>
      </div>
      <i class="el-icon-close close-btn" @click="hideNotice"></i>
    </div>

    <h1 class="home-h1">互联网行业服务平台</h1>
    <el-row class="home-describe" type="flex" justify="space-between" >
      <el-col class="describe-col">
        <el-image :src="require('@/assets/inventory.png')" alt="图标" />
        <h3>进销存</h3>
        <p>通过功能一体化、服务SAAS化、应用多终端化,让用户可以一站式、随时随地随手、更快速更准确更有效地处理工作,极大地提升了管理效率</p>
        <el-button type="text" size="small" @click="openWindow" disabled>了解详情 <i class="el-icon-arrow-right" /></el-button>
      </el-col>

      <el-col class="describe-col">
        <el-image :src="require('@/assets/erp.png')" alt="图标" />
        <h3>ERP</h3>
        <p>集采购、销售、库存管理和应收、应付款管理为一体，提供订单、采购、销售、退货、库存、往来发票、往来账款、业务员等的管理</p>
        <el-link type="primary" href="http://erp.runyuyunyin.com" target="_blank" >了解详情 <i class="el-icon-arrow-right" /></el-link>
      </el-col>

      <el-col class="describe-col">
        <el-image :src="require('@/assets/marketing.png')" alt="图标" />
        <h3>创新营销</h3>
        <p>为您实时捕捉用户行为，智能推荐创意，自动根据内容追投广告，为您节省成本；为客户提供全系列产品广告资源覆盖用户生活全场景</p>
        <el-button type="text" size="small" disabled>了解详情 <i class="el-icon-arrow-right" /></el-button>
      </el-col>
    </el-row>

    <el-row class="home-platform" type="flex" justify="center">
      <el-col :span="13">
        <div class="platform-list" :style="{'background-color':index === hoverIndex?'#1890ff':''}" v-for="(item,index) in listName" :key="index"
          @mouseenter="mouseenter(index)" @mouseleave="setTimer"
        >
          <el-image :src="require('@/assets/icon/icon1.png')" alt=""/>
          <div>
            <p style="text-align: left;">{{ item.title }}</p>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </el-col>

      <el-col v-if="start" class="animate__animated animate__fadeInRight" style="color:white;">
        <h2 >{{listName[hoverIndex].detail.title}}</h2>
        <h4 >{{listName[hoverIndex].detail.industry}}</h4>
        <p class="animate__animated animate__fadeInRight animate__slow" style="color: #999999;" >
          {{listName[hoverIndex].detail.detail}}
        </p>
        <h4 >{{listName[hoverIndex].detail.industryTwo}}</h4>
        <p class="animate__animated animate__fadeInRight animate__slow" style="color: #999999;" >
          {{listName[hoverIndex].detail.detailTwo}}
        </p>
        <div class="platform-understand">
          <el-link class="understand-name" :href="listName[hoverIndex].detail.href" target="_blank" :underline="false">了解详情</el-link>
          <span class="understand-title" @click="open = true">申请使用</span>
        </div>
      </el-col>
    </el-row>

    <h1 class="home-h1">新闻资讯</h1>

    <el-row class="home-news" :gutter="24">
      <el-col v-for="(item, index) in displayedArticles" :key="index" :span="6" class="news-col">
        <div>
          <div class="news-item" @click="goToNews(item.id)">
            <h3>{{ item.title }}</h3>
            <p>{{ item.remark }}</p>
            <el-button type="text" size="small" @click="goToNews(item.id)" style="color: #fff">了解详情 <i class="el-icon-arrow-right" /></el-button>
          </div>
        </div>
      </el-col>
      <!-- 显示更多按钮 -->
      <el-col v-if="articleCategoriesList.length > 7" :span="6" class="news-col">
        <div class="news-item more-item" @click="showAllArticles">
          <h3>更多资讯</h3>
          <i class="el-icon-more" style="font-size: 24px; color: #409EFF;"></i>
        </div>
      </el-col>
    </el-row>

    <h1 class="home-h1">我们拥有</h1>

    <el-row class="home-have" type="flex" justify="space-between">
      <el-col style="width: 20%;">
        <h2 class="wow animate__slideInUp" >50+</h2>
        <p>客户信赖之选</p>
      </el-col>

      <el-col style="width: 20%;">
        <h2 class="wow animate__slideInUp" >6,125,456</h2>
        <p>用户年交易总额</p>
      </el-col>

      <el-col style="width: 20%;">
        <h2 class="wow animate__slideInUp" >36＋</h2>
        <p>行业荣誉证书</p>
      </el-col>

      <el-col style="width: 20%;">
        <h2 class="wow animate__slideInUp" >26＋</h2>
        <p>技术团队支持</p>
      </el-col>
    </el-row>

    <h1 class="home-h1" v-show="displayedAdverts.length > 0">品牌传播</h1>

     <el-row class="home-advert" :gutter="24" v-show="displayedAdverts.length > 0">
      <el-col v-for="(item, index) in displayedAdverts" :key="index" :span="6" class="advert-col">
        <div>
          <div class="advert-item">
            <h3>{{ item.name }}</h3>
            <p class="content-body">
            <span v-html="$formatContent(item.content)"></span>
            <!-- <span v-if="item.content && item.content.length > 30"
                  class="show-more"
                  @click.stop="goDetail(item.id)">
              ...查看更多
            </span> -->
          </p>
          </div>
        </div>
      </el-col>
      <!-- 显示更多按钮 -->
      <el-col v-if="advert.length > 7" :span="6" class="advert-col">
        <el-link href="#" target="_blank" :underline="false">
          <div class="advert-item more-item" @click="showAllAdverts">
            <h3>更多</h3>
            <i class="el-icon-more" style="font-size: 24px; color: #409EFF;"></i>
          </div>
        </el-link>
      </el-col>
    </el-row>

    <el-dialog title="申请试用" :visible.sync="open" width="30%" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="96px" >
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入公司名称" clearable />
        </el-form-item>

        <el-form-item label="所属行业" prop="profession">
          <el-input v-model="form.profession" placeholder="请输入所属行业" clearable />
        </el-form-item>

        <el-form-item label="企业规模" prop="scale">
          <el-input v-model="form.scale" placeholder="请输入企业规模" clearable />
        </el-form-item>

        <el-form-item label="联系人" prop="contract">
          <el-input v-model="form.contract" placeholder="请输入联系人" clearable />
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话号码" clearable maxlength="11" />
        </el-form-item>

        <el-form-item label="验证码" prop="code" class="code">
          <el-input v-model.trim="form.code" style="width: 73%" prefix-icon="Lock" placeholder="请输入验证码" :disabled="form.phone == null" />
          <el-button class="login-code" style="width: 27%;height: 40px;" @click="showCodeDialog" :disabled="form.phone == null || codeTimer > 0">
            {{ codeTimer > 0 ? `${codeTimer}s后重新获取` : '获取验证码' }}
          </el-button>
        </el-form-item>

        <!-- 验证码弹框 -->
        <el-dialog title="请输入验证码" :visible.sync="codeDialogVisible" width="360px" append-to-body :close-on-click-modal="false">
          <div style="text-align: center;margin-bottom: 20px;">
            <el-image :src="codeUrl" style="width: 150px;height: 40px;cursor: pointer;" @click="handleCode" />
          </div>
          <el-input v-model="dialogParams.code" placeholder="请输入验证码" clearable />
          <span slot="footer">
            <el-button @click="codeDialogVisible = false; dialogParams = {}">取 消</el-button>
            <el-button type="primary" @click="confirmCode">确 定</el-button>
          </span>
        </el-dialog>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" clearable />
        </el-form-item>

        <el-form-item label="所在地区" prop="region">
          <el-input v-model="form.region" placeholder="请输入所在地区" clearable />
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址" clearable />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="open = false; form = {}; codeTimer = 0;">关闭</el-button>
        <el-button type="primary" @click="submit">提交审核</el-button>
      </span>
    </el-dialog>

    <el-dialog class="app-home-time" title="申请试用" :visible.sync="open2" width="300px" append-to-body>
      <i class="el-icon-time"></i>
      <h2>审核中</h2>
      <p class="time-text">
        已提交申请，等待审核 <br/>
        审核结果将以短信方式通知您！
      </p>
    </el-dialog>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import { articleClass, getCode, getSendSmsCode, merchantCheckIn  } from '@/api/index'
export default {
  computed: {
    sliderList() {
      return this.$store.state.getHomeData.sliderList
    },
    advert() {
      return this.$store.state.getHomeData.advert
    },
    notice() {
      return this.$store.state.getHomeData.notice
    },
    displayedAdverts() {
      return this.advert.slice(0, 7);
    },
    // displayedArticles() {
      // return this.articleCategoriesList.slice(0, 7);
    // }
  },
  data(){
    return{
      // 弹窗打开
      open:false,
      open2:false,
      // 表单提交
      form:{},
      // 数据验证
      rules:{
        company: { required: true, message: '请输入公司名称', trigger: 'blur' },
        profession:{ required: true, message: '请选择所属行业', trigger: 'change' },
        scale:{ required: true, message: '请选择公司规模', trigger: 'change' },
        contract:{ required: true, message: '请输入联系人', trigger: 'blur' },
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {pattern: /^[1,0][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code:{ required: true, message: '请输入验证码', trigger: 'blur' },
        email:{ required: true, message: '请输入邮箱', trigger: 'blur' },
        region:{ required: true, message: '请输入所在地区', trigger: 'blur' },
        address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
      },
      // 列表数据
      listName:[
        {
          title:'名片王',
          name:'智能名片,追踪用户轨迹',
          detail:{
            title : "ERP",
            industry:'集成管理软件系统',
            detail:'旨在帮助企业有效地管理和整合各种内部业务流程和资源，包括人力资源、财务、供应链、生产制造、销售和客户关系等方面。,整理,分析和利用,皆在建立和维护客户之前的良好关系,已促进销售和提升客户满意度',
            industryTwo:'企业资源计划',
            detailTwo:"ERP系统整合性强、信息共享方便、流程规范化等，能够帮助企业提高管理效率和决策水平。",
            href:'#',
          },
        },
        {
          title:'微店',
          name:'定制化企业微信系统',
          detail:{
            title : "小程序",
            industry:'技术优势',
            detail:'借助平台快速搭建自己的运行环境，用户无需下载安装，降低了使用门槛。便捷的更新和维护以及灵活的推广方式。',
            industryTwo:'便捷使用',
            detailTwo:"成熟的生产流程管理以及全面的数据分析和结果的展示，使用户能全面及时的了解生产情况，精准确定管理痛点，为后续的优化提高提供数据支撑。",
            href:'#',
          },
        },
        {
          title:'erp',
          name:'一站式,快递.准确,效率',
          detail:{
            title : "WEB网页端",
            industry:'技术优势',
            detail:'Web网页可以实现丰富的交互和多媒体内容，且具有较强的可定制性和灵活性，开发者可以灵活调整网页内容和功能，使得网页能够更好地满足用户的需求和期望。同时，网页的样式和布局也可以根据不同的设备和屏幕尺寸进行适配，保证在不同的设备上都能够良好地显示和使用。',
            industryTwo:'便捷使用',
            detailTwo:"用户可以通过搜索引擎轻松找到所需的信息，Web网页也能给用户提供更好的展示效果，用户可以在网页中更好的了解商品的规格样式，便捷的进行报价、下单和订单跟踪等。,能够帮助企业提高管理效率和决策水平。",
            href:'https://erp.runyuyunyin.com',
          },
        },
        {
          title:'进销存',
          name:'试试全面,及时掌握',
          detail:{
            title : "H5",
            industry:'技术优势',
            detail:'H5网页的跨平台兼容性、无需安装、更新便捷、成本效益高、易于分享和传播等特性使得其成为移动应用开发和移动网页设计的首选之一。',
            industryTwo:'便捷使用',
            detailTwo:"使用H5网页实现报价、下单已经订单跟踪，使用户能使用移动设备，随时随地报价、下订单以及查询订单信息状态。",
            href:'#',
          },
        }
      ],
      // 当前显示数据下标
      hoverIndex: 0,
      // 定时器
      timer:null,
      // 是否开始执行动画
      start:true,
      // 初始化wow
      wow : new WOW({
        boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 60,
        mobile: true,
        live: false
      }),
      currentNoticeIndex: 0, // 当前显示的滚动条下标
      noticeTimer: null, // 滚动条定时器
      articleCategoriesList: [], // 文章分类列表
      noticeHidden: false, // 控制公告栏显示隐藏
      displayedArticles: [], // 显示的新闻资讯列表
      dialogParams: {
        phone: null,
        code: null,
        uuid: null
      },
      codeUrl: '', // 验证码图片地址
      codeDialogVisible: false, // 验证码弹框显示状态
      codeTimer: 0,
      interval: null,
    }
  },
  created() {
    this.wow.init();
    this.setTimer();
    this.$store.dispatch('getHomeData');
    this.startNotice();
    this.getArticle();
    this.getNewsCategories();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods:{
    // 启动公告轮播
    startNotice() {
      this.noticeTimer = setInterval(() => {
        if (this.currentNoticeIndex >= this.notice.length - 1) {
          this.currentNoticeIndex = 0;
        } else {
          this.currentNoticeIndex++;
        }
      }, 3000);
    },

    // 设置定时器
    setTimer(){
      this.timer = setInterval(()=>{
        this.start = false;
        if (this.hoverIndex >= this.listName.length-1) {
          this.hoverIndex = 0;
        }else{
          this.hoverIndex++;
        }
        this.$nextTick(()=>{
          this.start = true;
        })
      },4000)
    },
    // 鼠标移入
    mouseenter(index){
      this.hoverIndex = index;
      clearInterval(this.timer);
    },
    // 重置表单
    reset(){
      this.form = {
        name: null,         // 姓名
        industry:null,      // 行业
        contacts:null,      // 联系人
        phone: null,        // 手机
        scale:null,         // 公司规模
        location:null,      // 地址
        detailed:null,      // 详细地址
      };
    },
    // 打开窗口
    openWindow(){
      this.open = true;
      this.reset();
      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
    },
    // 提交
    submit(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          merchantCheckIn(this.form).then(res => {
            if(res.code === 200)  {
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.open = false;
              // this.open2 = true
              this.$refs['form'].resetFields();
            } else {
              this.$message({
                type: 'error',
                message: '提交失败'
              });
            }
          });
        }
      });
    },

    // 文章分类
    getArticle() {
      articleClass().then(res => {
        if (res.data.rows) {
          // 过滤掉 status 为 0 的数据
          this.articleCategoriesList = res.data.rows.filter(item => item.status !== 0);
        } else {
          this.articleCategoriesList = [];
        }
      })
    },
    showAllAdverts() {
      // 这里可以根据需求实现查看更多的逻辑
    },
    showAllArticles() {

    },
    // 获取新闻资讯分类
    getNewsCategories() {
      articleClass({classify_id: 4}).then(res => {
        if (res.data.rows) {
          this.articleCategoriesList = res.data.rows.filter(item => item.status !== 0);
          this.displayedArticles = this.articleCategoriesList.slice(0, 7);
        } else {
          this.articleCategoriesList = [];
          this.displayedArticles = [];
        }
      })
    },
    // 新闻资讯
    goToNews(id) {
      this.$router.replace({
        path: '/new',
        replace: true,
        query: { classify_id: 4, id: id }
      }).catch(() => {})
    },
    hideNotice() {
      this.noticeHidden = true;
    },

    // 获取验证码
    handleCode() {
      getCode().then(res => {
        if(res.code == 200) {
          this.codeUrl = res.img;
          this.dialogParams.uuid = res.uuid;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 显示验证码弹框
    showCodeDialog() {
      this.codeDialogVisible = true
      this.handleCode()
      this.dialogParams.phone = this.form.phone
    },

    // 确认验证码
    confirmCode() {
      if (!this.dialogParams.code) {
        this.$message.warning('请输入验证码')
        return
      }
      this.codeDialogVisible = false
      this.getSmsCode()
      this.dialogParams = {}
    },

    // 获取短信验证码
    getSmsCode() {
      getSendSmsCode(this.dialogParams).then(res => {
        if(res.code == 200) {
          this.$message.success('验证码已发送')
          this.startTimer()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    startTimer() {
      if (this.codeTimer > 0) return
      // 先开始倒计时
      this.codeTimer = 60
      this.interval = setInterval(() => {
        if (this.codeTimer > 0) {
          this.codeTimer--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.app-home {
  background-color: white;
  .home-carousel{
    min-height: 160px;
  }
  .notice-bar {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #FFF3E0;
    padding: 8px 20px;
    border-radius: 4px;
    min-width: 300px;
    z-index: 10;
    font-size: 12px;
    .el-icon-bell {
      color: #FFA23F;
      margin-right: 10px;
      font-size: 14px;
    }
    .notice-content {
      color: #FFA23F;
      overflow: hidden;
      display: inline;
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          p {
            margin-top: 0;
          }
        }
      }
    }
    .close-btn {
      margin-left: 10px;
      cursor: pointer;
      color: #FFA23F;
      font-size: 14px;
      &:hover {
        color: #ff8c00;
      }
    }
  }


  .home-h1{
    font-size: clamp(1rem, 0.682rem + 1.59vw, 1.875rem);
    text-align: center;
  }
  .home-describe,.home-news,.home-have, .home-advert{
    width: 77%;
    margin: 0 auto 2vw auto;
    .describe-col{
      width: 28%;
      text-align: center;
      .el-image{
        vertical-align: middle;
      }
      p{
        color: #999999;
      }
    }
  }
  .home-platform{
    height: 32vw;
    padding: 5% 15vw;
    overflow: hidden;
    background-image: url('~@/assets/banner/banner1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .platform-list{
      padding: 5%;
      color: #fff;
      width: 255px;
      display: flex;
      align-items: center;
      p{
        margin: 3px 0 3px 20px;
      }
      .el-image{
        width: 20px;
      }
    }
    .platform-understand{
      margin: 20px 0;
      display: flex;
      .understand-name,.understand-title{
        width: 130px;
        height: 35px;
        line-height: 35px;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        cursor: pointer;
        text-align: center;
        border: 1px solid rgba(255,255,255,1);
      }
      .understand-title{
        margin-left: 20px;
        color: #000;
        background-color: #fff;
      }
    }
  }
  .home-news, .home-advert{
    width: 100%;
    // height: 500px;
    overflow: auto;
    text-align: center;
    padding-left: 11.5%;
    padding-right: 11.5%;
    .news-col, .advert-col {
      margin-bottom: 20px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .news-item, .advert-item {
      padding: 20px;
      border: 1px solid #eee;
      border-radius: 10px;
      width: 200px;
      height: 100px;
      transition: all 0.3s;
      text-align: left;
      overflow: auto;
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      }
      h3 {
        margin-top: 0;
        font-size: 16px;
        color: #fff;
      }
      p {
        color: #666;
        font-size: 14px;
        line-height: 1.6;
        margin: 10px 0;
        text-align: left;
      }
    }

    .el-image{
      width: 100%;
      vertical-align: middle;
    }
    p{
      font-size: 14px;
      text-align: left;
    }
    .news-text{
      height: 3vw;
      margin: 0;
      line-height: 3vw;
      border: 1px solid #ccc;
      border-top: none;
      padding-left: 10px;
      color: #333;
    }
    .news-item {
       background: url('../assets/news/new_bg.png') no-repeat;
       background-size: 100% 100%;
      //  h3 {
      //   color: #fff;
      //  }
    }
    .advert-item {
      background: url('../assets/news/advert_bg.png') no-repeat;
      background-size: cover;
      // h3 {
      // color: #fff;
      // }
    }
  }
  .home-have{
    text-align: center;
    margin: 0 auto;
    padding: 0 0 2vw 0;
    h2{
      color: red;
    }
    p{
      font-size: 14px;
      color: #999999;
    }
  }
}
.app-home-time{
  .el-dialog__body{
    text-align: center;
    .el-icon-time{
      color: #E6A23C;
      font-size: 80px;
    }
    .time-text{
      font-size: 14px;
    }
  }
}
.content-body {
  font-size: 14px;
  text-indent: 2em;
  span {
    color: #fff;
  }

  .show-more {
    color: #409EFF;
    cursor: pointer;
    margin-left: 5px;

    &:hover {
      text-decoration: underline;
    }
  }
}

// 添加过渡动画
.notice-enter-active, .notice-leave-active {
  transition: all 0.5s;
}
.notice-enter {
  transform: translateY(20px);
  opacity: 0;
}
.notice-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
